var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "shopReview" }, [
    _c(
      "div",
      { staticClass: "shopReview__header" },
      [
        _c("div", { staticClass: "shopReview__isCompany" }, [
          _vm._v(_vm._s(_vm.shopReview.is_company ? "法人利用" : "個人利用")),
        ]),
        _vm._v(" "),
        _c("views-rating-stars", {
          attrs: { rating: _vm.shopReview.average_rating },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "shopReview__usage" }, [
      _vm._v("利用用途 | " + _vm._s(_vm.shopReview.category_label)),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "shopReview__title" }, [
      _vm._v(_vm._s(_vm.shopReview.title)),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "shopReview__contents" }, [
      _vm.isExpanded
        ? _c("span", [_vm._v(_vm._s(_vm.shopReview.contents))])
        : _c("span", [_vm._v(_vm._s(_vm.truncatedContents))]),
      _vm._v(" "),
      _vm.shouldShowMoreLink && !_vm.isExpanded
        ? _c(
            "a",
            {
              attrs: { href: "#" },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.expand.apply(null, arguments)
                },
              },
            },
            [
              _vm._v("もっと見る"),
              _c("i", { staticClass: "fas fa-chevron-down" }),
            ]
          )
        : _vm._e(),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "shopReview__price" }, [
      _c("div", { staticClass: "shopReview__price__container" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("span", { staticClass: "shopReview__price-label" }, [
          _vm._v("費用明細"),
        ]),
        _vm._v(" "),
        _c("span", { staticClass: "shopReview__price-people" }, [
          _vm._v(_vm._s(_vm.shopReview.people) + "名/\n        "),
          _c("span", { staticClass: "shopReview__price-amount" }, [
            _vm._v(
              _vm._s(_vm._f("formatCurrency")(_vm.shopReview.total_price))
            ),
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "shopReview__price-currency" }, [
            _vm._v("円"),
          ]),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "shopReview__meta" }, [
      _c("span", [_vm._v("訪問日 " + _vm._s(_vm.visitDate))]),
      _vm._v(" "),
      _c("span", [_vm._v("投稿日 " + _vm._s(_vm.createdAt))]),
      _vm._v(" "),
      _c("span", [
        _vm._v("記入者 男性 : " + _vm._s(_vm.shopReview.age) + "代"),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "shopReview__price-yen" }, [
      _c("span", [_vm._v("¥")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }